<template>
    <div class="box-offset">
        <div class="box-ttl-wrap">
            <div class="box-ttl">
                Permissions
            </div>
        </div>
        <div class="form mt-3">
            <div class="row">
                <div class="col-lg-12">
                    <div class="table-holder table-responsive ">
                        <table class="table permissions-table">
                            <tbody>
                            <tr style="display: flex;flex-direction: column; border: none"
                                v-for="category in updatedCategories"
                                :key="category.id"
                                >
                                <td class="main-permission-row" style="border-bottom: 1px solid rgba(171, 171, 171, .5);">
                                    <div class="form-group form-group-1">
                                        <div class="form-check">
                                            <b><div class="form-check-label">{{category.title}}</div></b>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    class="sub-permission-row"
                                    style="border-bottom: 1px solid rgba(171, 171, 171, .5);"
                                    v-for="permission in category.permissions"
                                    :key="permission.id"
                                >
                                    <div class="form-group form-group-1">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="checkbox"
                                                :id="permission.id"
                                                v-model="permission.isChecked"
                                                @change="checkPermission(permission)"
                                            >
                                            <label class="form-check-label" :for="permission.id">{{permission.title}}</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns-wrap mt-4">
            <button  class="btn btn--outline-primary w-100 w-sm-auto" @click="reloadPage">Cancel</button>
            <button class="btn btn--secondary w-100 w-sm-auto" @click="saveChanges">Save</button>
        </div>
    </div>
</template>

<script>
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import UsersServices from "../services/UsersServices";

export default {
    name: 'Permissions',
    mixins: [ModalHandler],
    props: {
        listOfPermissions: {
            type: Array,
        },
        userPermissions: {
            type: Array,
            required: true,
        },
        id: {
            type: Number
        }
    },
    data() {
        return {
            updatedCategories: [],
            checkedPermissions: [],
        }
    },
    methods: {
        addCheckbox() {
            this.updatedCategories = this.listOfPermissions.map(category => {
                let updatedPermissions = category.permissions.map(permission => {
                    return { ...permission, isChecked: false };
                });
                return { ...category, permissions: updatedPermissions };
            });
            if (this.userPermissions) {
                this.setCheckedPermissions()
            }
        },
        checkPermission(permission) {
            if (permission.isChecked === true) {
                this.checkedPermissions.push(permission.id);
            } else {
                const index = this.checkedPermissions.findIndex(p => p === permission.id);
                if (index !== -1) {
                    this.checkedPermissions.splice(index, 1);
                }
            }
        },
        findDefaultChecked() {
            const checked = this.userPermissions.map(i => i.id);
            this.checkedPermissions = this.checkedPermissions.concat(checked);
        },
        setCheckedPermissions() {
            this.updatedCategories.forEach(category => {
                category.permissions.forEach(permission => {
                    const foundPermission = this.userPermissions.find(item => item.id === permission.id);
                    if (foundPermission) {
                        permission.isChecked = true;
                    }
                });
            });
        },
        async saveChanges() {
            this.$showLoadingMessage()
            try {
                await UsersServices.updatePermissions(this.id, this.checkedPermissions)
                this.$showSuccessMessage('Permissions has been updated')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Permissions was not updated. Please try again')
            }
        }
    },
    mounted() {
        this.addCheckbox()
        this.findDefaultChecked()
    }
}

</script>



<style scoped>

</style>
